import store from '@/store'
import { computed } from '@vue/composition-api'

export default function useWorkflows ({ product, workflowIdReactive = [] }) {
  const workflowsByProduct = computed(() => Object
    .values(store.getters.approvalWorkflows || {})
    .filter(workflow => workflow.type === product))

  const workflowIdsByProduct = computed(() => workflowsByProduct.value.map(workflow => workflow.id))

  const workflowFieldSettings = computed(() => {
    const workflowsMapByName = {}
    const workflowsMapById = {}
    workflowsByProduct.value.forEach(workflow => {
      const workflowName = workflow.name || workflow.id
      workflowsMapByName[workflowName] = workflowsMapByName[workflowName] || []
      workflowsMapById[workflow.id] = workflowName
      if (!workflowsMapByName[workflowName].includes(workflow.id)) {
        workflowsMapByName[workflowName].push(workflow.id)
      }
    })
    const workflowIds = Object.keys(workflowsMapByName)
      .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
      .map(workflowName => workflowsMapByName[workflowName])
    return {
      workflowsMapById,
      workflowIds,
    }
  })
  const workflowStepFieldSettings = computed(() => {
    const stepsMapByName = {}
    const stepsMapById = {}
    const stepsIdToWorkflowIdMap = {}
    const currentWofkflows = workflowsByProduct.value.filter(workflow => workflowIdReactive.value?.includes(workflow.id)) || []
    currentWofkflows.forEach(workflow => {
      workflow.steps.forEach(workflowStep => {
        const stepName = workflowStep.name || workflowStep.id
        stepsMapByName[stepName] = stepsMapByName[stepName] || []
        stepsMapById[workflowStep.id] = stepName
        stepsIdToWorkflowIdMap[workflowStep.id] = [ ...(stepsIdToWorkflowIdMap[workflowStep.id] || []), workflow.id ]
        if (!stepsMapByName[stepName].includes(workflowStep.id)) {
          stepsMapByName[stepName].push(workflowStep.id)
        }
      })
    })
    const currentWorkflowStepIds = Object.values(stepsMapByName)
    return {
      stepsMapById,
      currentWorkflowStepIds,
      stepsIdToWorkflowIdMap,
    }
  })

  return {
    workflowsByProduct,
    workflowIdsByProduct,
    workflowFieldSettings,
    workflowStepFieldSettings,
  }
}
